import {nextTick, ref, type Ref, shallowRef, type ShallowRef, watchEffect} from "vue";
import {useGeolocation} from "@vueuse/core";
import {latLng, LatLng, latLngBounds} from "leaflet"

export interface UserLocationService {
  zoom: Ref<number>;
  location: ShallowRef<LatLng>;
}

const defaultLocationGermany = latLng(51.02349, 10.047401)

// Source: https://gist.github.com/graydon/11198540
export const germanyMaxBounds = latLngBounds(latLng(47.3024876979, 5.98865807458), latLng(54.983104153, 15.0169958839))

export function useUserCurrentLocation(): UserLocationService {
  const zoom = ref(6);
  const location = shallowRef<LatLng>(defaultLocationGermany);

  const geo = useGeolocation();

  watchEffect(() => {
    if (geo.isSupported.value) {
      const result = (geo.coords as Ref<any>).value;
      if (Number.isFinite(result.latitude) && Number.isFinite(result.longitude)) {
        location.value = latLng(result.latitude, result.longitude);
        zoom.value = 10; // Zoom in closer when location is found

        void nextTick(() => geo.pause()); // Stop updating location
      }
    }
  });

  return {zoom, location};
}
